"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class GroupIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { id: "icon/24/group/group-light", fill: fill },
                    React.createElement("g", { transform: "translate(5.000000, 5.000000)" },
                        React.createElement("rect", { x: "0", y: "0", width: "5", height: "5" }),
                        React.createElement("rect", { x: "9", y: "0", width: "5", height: "5" }),
                        React.createElement("rect", { x: "0", y: "9", width: "5", height: "5" }),
                        React.createElement("rect", { x: "9", y: "9", width: "5", height: "5" }))))));
    }
}
exports.GroupIcon = GroupIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/group.tsx
// module id = 2146
// module chunks = 0 1 2